// Renders a paragraph of text, turning inline "[1]", "[2]"... citation
// markers into small jump-links to the matching entry in the Sources list.
export function CitedText({ text, className = "" }) {
  const parts = text.split(/(\[\d+\])/g);
  return (
    <p className={className}>
      {parts.map((part, i) => {
        const match = part.match(/^\[(\d+)\]$/);
        if (!match) return <span key={i}>{part}</span>;
        return (
          <a
            key={i}
            href={`#source-${match[1]}`}
            data-testid={`newsletter-citation-${match[1]}`}
            className="text-accent no-underline hover:underline align-super text-[0.7em] ml-0.5"
          >
            {part}
          </a>
        );
      })}
    </p>
  );
}
